const TOPICS = [
  { label: '暑期档', hot: true, count: '1.2万' },
  { label: '国产剧', hot: true, count: '9800+' },
  { label: '悬疑片', hot: true, count: '8600+' },
  { label: '科幻大片', hot: false, count: '7200+' },
  { label: '韩剧', hot: true, count: '6500+' },
  { label: '动漫', hot: false, count: '5800+' },
  { label: '喜剧', hot: false, count: '5100+' },
  { label: '美剧', hot: true, count: '4900+' },
  { label: '纪录片', hot: false, count: '3600+' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
            热门话题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            大家都在看什么
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            热门影视话题标签，看看最近什么最火
          </p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center max-w-3xl mx-auto">
          {TOPICS.map((topic, i) => (
            <a
              key={i}
              href="#media"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium border transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 text-primary-700 border-primary-200 hover:bg-primary-100'
                  : 'bg-background-100 text-foreground-600 border-background-200 hover:bg-background-200'
              }`}
            >
              {topic.label}
              {topic.hot && (
                <i className="ri-fire-line text-accent-500 text-xs"></i>
              )}
              <span className="text-xs opacity-70">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}